var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJadbery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 202.75 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,.55V20.82C22,27,18.71,31.5,10.5,31.5H0V26.09H10.18c4.86,0,6.33-2.34,6.33-5.32V.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.45,31.5h-6L35.36,4c1.14-2.89,3.25-4,6.51-4s5.32,1.1,6.42,4L58.74,31.5h-6L43.33,6.6a1.47,1.47,0,0,0-1.51-1,1.57,1.57,0,0,0-1.56,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.69.55H63.24V6h6.45c6,0,8.53,3,8.53,10S75.7,26.09,69.69,26.09H63.24V31.5h6.45c9.08,0,13.94-5,13.94-15.45S78.73.55,69.69.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.15,6h10V.55h-10C117.86.55,114.79,4,114.79,9c0,3.39,1.46,5.77,4.35,7-2.84,1.19-4.45,3.57-4.45,7.1,0,4.82,3,8.44,10.32,8.44h10.12V26.09H125c-3.16,0-4.68-1.47-4.68-3.9s1.61-3.76,4.73-3.76h10.07V13.52h-9.94c-3.11,0-4.72-1.14-4.72-3.66S121.89,6,125.15,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.8,9.59c0,2.52-1.61,3.66-4.72,3.66H88.14v4.91H98.21c3.12,0,4.73,1.24,4.73,3.76s-1.52,3.9-4.68,3.9H88.14v5.41H98.26c7.34,0,10.32-3.62,10.32-8.44,0-3.53-1.61-5.91-4.45-7.1,2.89-1.2,4.35-3.58,4.35-7,0-5-3.07-8.44-10.36-8.44h-10V5.69h10C101.38,5.69,102.8,7.2,102.8,9.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.76.55c7,0,10,4.31,10,9.26,0,3.86-1.83,8-6.55,9.31l7.2,12.38h-6l-7.06-12h-8.07a.68.68,0,0,0-.78.78V31.5H142V19.26c0-3.49,1.47-4.91,4.86-4.91H159A4,4,0,0,0,163.26,10c0-2.2-1.33-4.08-4.31-4.08H142V.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.33.55l-10,15.3a9.24,9.24,0,0,0-1.51,5.07V31.5h5.45V21.12a9.28,9.28,0,0,1,1.7-5.37L202.75.55Zm-17.42,0h-6.56L183,15.63l2.86-4.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJadbery);
export default __webpack_public_path__ + "static/media/jadbery.9bdd9a3548762a013d4a067a61fe1d9a.svg";
export { ForwardRef as ReactComponent };